// extracted by mini-css-extract-plugin
module.exports = {"timer":"timer_timer__1GGzs","time_unit-wrapper":"timer_time_unit-wrapper__3hhIO","time_unit":"timer_time_unit__10eDB","time_unit-label":"timer_time_unit-label__2hvQs"};